import sectionTpl from './base';

export { sectionTpl }